import { add, sub, ZERO, type Decimal } from '../core/decimal.ts';
import type { Frequency } from '../types/domain.ts';
import { monthlyEquivalent } from './frequency.ts';

export interface ScenarioAdjustment {
  readonly type: 'income' | 'expense' | 'oneTime';
  readonly amount: Decimal;
  readonly frequency: Frequency;
}

/** Scenario.monthlyImpact: Σ ±amount × Decimal(annualOccurrences) / 12, skipping one-time adjustments. */
export const scenarioMonthlyImpact = (adjustments: readonly ScenarioAdjustment[]): Decimal =>
  adjustments.reduce<Decimal>((total, adjustment) => {
    if (adjustment.type === 'oneTime') return total;
    const monthly = monthlyEquivalent(adjustment.frequency, adjustment.amount);
    return adjustment.type === 'income' ? add(total, monthly) : sub(total, monthly);
  }, ZERO);
